var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6862 5H6.31406C5.14817 5 4.55993 6.41452 5.38598 7.24057L9.8125 11.6687V16.375C9.8125 16.7881 10.007 17.1771 10.3375 17.4688L12.0875 18.7557C12.9426 19.3533 14.1875 18.7978 14.1875 17.7057V11.6687L18.6143 7.24057C19.4387 6.41619 18.8544 5 17.6862 5ZM12.875 11.125V17.6875L11.125 16.375V11.125L6.3125 6.3125H17.6875L12.875 11.125Z",
    fill: "#1B2437"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductFilter);
export default __webpack_public_path__ + "static/media/product-filter.c64f442237deb11fd54cdcac13980f85.svg";
export { ForwardRef as ReactComponent };